import type { AllRouteEndpoints } from "../routeTypes";

export const knowledgeSourceDefinitionCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/knowledge_source/definitions",
];
